module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "other"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "otherfm2"
    }
  }), _c('strong', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS BY")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERZY")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSINSKI")])])]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("NOVELS"), _c('br'), _vm._v("The Painted Bird"), _c('br'), _vm._v("Steps"), _c('br'), _vm._v("Being There"), _c('br'), _vm._v("The Devil Tree"), _c('br'), _vm._v("Cockpit"), _c('br'), _vm._v("Blind Date"), _c('br'), _vm._v("Passion Play"), _c('br'), _vm._v("Pinball"), _c('br'), _vm._v("The Hermit of 69th Street")]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("ESSAYS"), _c('br'), _vm._v("Passing By"), _c('br'), _vm._v("Notes of the Author"), _c('br'), _vm._v("The Art of the Self")]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("NONFICTION"), _c('br'), _c('em', [_vm._v("(Under the pen name Joseph Novak)")]), _c('br'), _vm._v("The Future Is Ours, Comrade"), _c('br'), _vm._v("No Third Path")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a00fd99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm2.vue
// module id = 69
// module chunks = 0